module.exports = __webpack_public_path__ + "static/media/report-cover-background.cbc2b69d.jpg";